import React, {useEffect, useState} from 'react';
import styles from './index.module.less';
import {
  Button,
  Callout,
  Card,
  Classes,
  Collapse,
  Intent,
  Radio,
  RadioGroup
} from "@blueprintjs/core";
import Markdown from "../Markdown";

const SingleChooseQuestion = ({ exercise, onSubmit }) => {
  const [value, setValue] = useState();
  const [answered, setAnswered] = useState(false);
  const [tipsOpen, setTipsOpen] = useState(false);

  useEffect(() => {
    if ((exercise.selectedAnswer || []).length > 0) {
      setValue(exercise.selectedAnswer[0]);
      setAnswered(true);
    }
  }, [exercise]);

  const handleAnswer = (e) => {
    if (answered) {
      return;
    }
    const answer = e.currentTarget.value;
    setValue(answer);
    setAnswered(true);
    onSubmit(exercise.id, [answer]);
  };

  return (
    <div className={styles['single-choose-question']}>
      <Card>
        <h5 className={Classes.HEADING}>单项选择题：请选择下列选型中描述正确的一项</h5>
        {exercise.desc && <Markdown content={exercise.desc} />}
        <RadioGroup disabled={answered} selectedValue={value} onChange={handleAnswer}>
          {exercise.options.map(option => <Radio key={option.key} large label={`${option.key}. ${option.content}`} value={option.key} />)}
        </RadioGroup>
      </Card>
      <Callout intent={answered ? (exercise.answer[0] === value ? Intent.SUCCESS : Intent.DANGER) : ''} className={styles['tips-container']}>
        <div className={styles['tips-title']}>
          <h5 className={Classes.HEADING}>
            {answered ? (exercise.answer[0] === value ? '回答正确' : `答案错误，正确选项：${exercise.answer[0]}`) : '查看答案解析'}
          </h5>
          <Button outlined small icon={tipsOpen ? 'chevron-up' : 'chevron-down'} onClick={() => setTipsOpen(!tipsOpen)} />
        </div>
        <Collapse isOpen={tipsOpen}>
          {exercise.tips}
        </Collapse>
      </Callout>
    </div>
  );
};

export default SingleChooseQuestion;
